import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { allFilterPages } from '@features/filter/static/filterUtil';
import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const PositionList = ({ filterPageName }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setData(allData);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.POM_LIST]: dependentFilterList?.positionList
	};

	const onFetchData = async () => {
		let responseData = filterData[filterPageName]?.map((item) => ({ ...item, id: item?.constant }));
		setAllData(responseData);
		setData(responseData);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allData?.filter((item) => item?.name?.toLowerCase().includes(e.target.value.toLowerCase()))
			: allData;
		setData(searchResult);
	};
	return (
		<>
			<FilterName type="POSITION_LIST" />
			<Checkbox data={data} type="POSITION_LIST" handleSearch={handleSearch} />
		</>
	);
};

export default PositionList;
